import React from 'react';
import { Warning } from './OlympiadDetailsStyled';
import DownloadButton from '../DownloadButton';
import Tooltip, { TooltipPlacement } from 'features/shared/Tooltip';

import { LogClick, useClickStreamContext } from 'features/shared/ClickStream';

const DownloadReportButton = (props: {
  pendingReport?: boolean;
  onDownloadReport?: () => void;
  olympiadId: string;
  disabled: boolean;
}) => {
  const { logPageEvent } = useClickStreamContext();
  const { pendingReport, onDownloadReport } = props;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip
        title="Учитывается статистика с 1 класса. Чтобы посмотреть результаты по дошкольникам, обратитесь к менеджеру."
        arrow
        width={280}
        placement={TooltipPlacement.TopStart}
        onShow={() => {
          logPageEvent?.({
            eventType: 'olymp_show_tooltip_statistics_from_first_class',
            eventInfo: 'Олимпиада: Показ тултипа "Учитывается статистика с 1 класса"',
            cd1: props.olympiadId,
          });
        }}
      >
        <Warning />
      </Tooltip>
      <LogClick
        eventType="olymp_upload_to_excel"
        eventInfo="Олимпиада: Клик по кнопке Выгрузить в Excel"
        cd1={props.olympiadId}
      >
        <DownloadButton isDisabled={pendingReport || props.disabled} onClick={onDownloadReport}>
          {pendingReport ? 'Идет загрузка' : 'Выгрузить в Exсel'}
        </DownloadButton>
      </LogClick>
    </div>
  );
};

export default DownloadReportButton;
